import { GlobalSmsSettings } from './GlobalSmsSettings';

export default GlobalSmsSettings;
